//----- Component --------------------------------------------------------/

// Developer :  Nicolas Pascucci

// Creation Date : 11/02/2025

// Version : 1

// Description : tabla de empleados de rrhh

//

//------Changes --------------------------------------------------------------------- -------------//

// Change Date :

// Change by :

// Change description:

//

// Change Date :

// Change by :

// Change description:

//
//========================================================================/
import React, { useState, useEffect, useMemo, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import MaterialReactTable, {
  MRT_FullScreenToggleButton,
} from "material-react-table";
import { MRT_Localization_ES } from "material-react-table/locales/es"; //Tabla en español
import {
  Container,
  Box,
  Typography,
  IconButton,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Grid,
} from "@mui/material";
import { createTheme, ThemeProvider, useTheme } from "@mui/material";
import MuiAlert from "@mui/material/Alert";

// ICONOS
import EditIcon from "@mui/icons-material/Edit";
import FileDownloadIcon from "@mui/icons-material/FileDownload";

import { getData } from "../../../services/library";
import Navbar from "../../Navbar";
import DetalleEmpleado from "./DetalleEmpleado";
import EditarEmpleado from "./EditarEmpleado";
import AgregarEmpleado from "./AgregarEmpleado";

import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import BlockIcon from "@mui/icons-material/Block";
import { blueGrey, grey } from "@mui/material/colors";
import { UrlApi } from "../../../services/apirest";
import { logEventos } from "../../../services/services";
import DeleteIcon from "@mui/icons-material/Delete";
import { ExportToCsv } from "export-to-csv";

const Alert = React.forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

function Stock_empleados(props) {
  let navigate = useNavigate();
  const location = useLocation();
  const [empleados, setEmpleados] = useState();
  const [tabla, setTabla] = useState(true);
  const [editarEmpleado, setEditarEmpleado] = useState(false);
  const [agregarEmpleado, setAgregarEmpleado] = useState(false);
  const [row, setRow] = useState();

  // activos - inactivos
  const [hiddenmuestrainactivo, setHiddenmuestrainactivo] = useState(false);
  const [hiddenmuestraactivos, setHiddenmuestraactivos] = useState(true);
  const [error, setError] = useState(null); //guardará el error que lance la api (si existe)
  const [notificacion, setNotificacion] = useState(false); //define si se muestra o no una notificación (snackbar)
  const [openSnack, setOpenSnack] = React.useState(false); //abre y cierra snack
  const [mensaje, setMensaje] = useState(""); //mensaje q mostrará la notif
  const [datosEmpleado, setDatosEmpleado] = useState({});
  const [confirmar, setConfirmar] = useState(false);


  const obtenerActivos = () => {
    setHiddenmuestraactivos(true);
    setHiddenmuestrainactivo(false);
    getData("/stock_empleados/todosactivos", setEmpleados);
  };

  const obtenerinactivos = () => {
    setHiddenmuestrainactivo(true);
    setHiddenmuestraactivos(false);
    getData("/stock_empleados/todosinactivos", setEmpleados);
  };


  //ejecuta la funcion de obtener
  useEffect(() => {
    obtenerActivos();
  }, [tabla]);

  const abrirModalConfirmar = (datosDeLaLinea) => {
    setConfirmar(true);
    setDatosEmpleado(datosDeLaLinea);
  };
  const handleVolver = () => {
    setConfirmar(false);
    setTabla(true);
  };
  
  const marcarInactivo = async (e) => {
    logEventos(
      "Guardar empleado inactivo",
      "Stock Empleados",
      "Se guardo empleado inactivo",
      localStorage.getItem("user")
    );
    e.preventDefault();
    const response = await fetch(
      UrlApi + "/stock_empleados/" + datosEmpleado.id,
      {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(
          datosEmpleado.estado === 0 ? { estado: 1 } : { estado: 0 }
        ),
      }
    );
    if (response.ok === false) {
      const error = response && response.json();
      setError(error);
      alert("Inconvenientes con la API. No se pudo guardar. ");
    } else {
      try {
        const json = await response.json();
        if (json.message) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje(
            json.message === "OK" ? "Guardado" : "Guardado. Actualizar RTA Api."
          );
          obtenerActivos();
        } else if (json.sqlMessage) {
          json && setError(json);
          alert("SQL erróneo (" + json.code + " Errno: " + json.errno + " )");
        } else {
          alert("ERROR DESCONOCIDO.");
        }
      } catch (error) {
        if (error.toString().includes("is not valid JSON")) {
          setNotificacion(true);
          setOpenSnack(true);
          setMensaje("Guardado");
          obtenerActivos();
        } else {
          alert("Error: " + error);
        }
      }
    }
    handleVolver();
    obtenerActivos();
  };

  const handleClickEditarEmpleado = (row) => {
    setRow(row);
    setEditarEmpleado(true);
  };

  const handleCloseEditar = () => {
    setEditarEmpleado(false); // Cierra el diálogo
    obtenerActivos();
  };

  const handleClickAgregarEmpleado = (row) => {
    setAgregarEmpleado(true);
  };

  const handleCloseAgregar = () => {
    setAgregarEmpleado(false); // Cierra el diálogo
    obtenerActivos();
  };

  const columns = useMemo(
    () => [
      { header: "N° Legajo", accessorKey: "nro_legajo", size: 130 },
      { header: "Sucursal", accessorKey: "sucursal_nombre", size: 130 },
      { header: "Puesto", accessorKey: "puesto_nombre", size: 130 },
      {
        header: "Nombre",
        accessorKey: "nombre",
        size: 130,
      },
      {
        header: "Apellido",
        accessorKey: "apellido",
        size: 110,
      },
      {
        header: "DNI",
        accessorKey: "dni",
        size: 60,
      },
    ],
    []
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    size: "small",
  };
  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };
  //*************************************************************************************************************************************//
  const globalTheme = useTheme();
  const tableTheme = useMemo(
    () =>
      createTheme({
        palette: {
          mode: globalTheme.palette.mode,
          primary: globalTheme.palette.primary, //primary color for the table
          info: {
            main: "rgb(255,122,0)", //add in a custom color for the toolbar alert background stuff
          },
          background: {
            default:
              globalTheme.palette.mode === "light"
                ? "rgb(234, 239, 241)"
                : "#000", //pure black table in dark mode for fun
          },
        },
        typography: {
          button: {
            textTransform: "none", //customize typography styles for all buttons in table by default
            fontSize: "1rem",
          },
        },
        components: {
          MuiTooltip: {
            styleOverrides: {
              tooltip: {
                fontSize: "0.8rem",
              },
            },
          },
        },
      }),
    [globalTheme]
  );

  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 10 },
    grouping: ["sucursal_nombre"],
  };

const handleExportCSV = () => {
  const dataToExport = empleados.map(empleado => ({
    'Legajo': empleado.nro_legajo || 'N/A',
    'Nombre Empleado': `${empleado.nombre} ${empleado.apellido}`,
    'Sucursal': empleado.sucursal_nombre || 'N/A',
    'Puesto': empleado.puesto_nombre || 'N/A',
    'Talle Pantalón': empleado.talle_pantalon || 'N/A',
    'Talle Remera': empleado.talle_remera || 'N/A',
    'Talle Buzo': empleado.talle_buzo || 'N/A',
    'Talle Campera': empleado.talle_campera || 'N/A',
    'Talle Botín': empleado.talle_botin || 'N/A',
    'Talle Faja': empleado.talle_faja || 'N/A',
    // 'Fecha': new Date().toLocaleDateString()
  }));

  const options = {
    filename: `empleados_${new Date().toLocaleDateString()}`,
    fieldSeparator: ';',
    quoteStrings: '"',
    decimalSeparator: ',',
    showLabels: true,
    showTitle: true,
    title: 'Empleados',
    useTextFile: false,
    useBom: true,
    useKeysAsHeaders: true,
  };

  const csvExporter = new ExportToCsv(options);
  csvExporter.generateCsv(dataToExport);
};

console.log(empleados);

useEffect(() => {
  logEventos(
    "acceso al menú Empleados", 
  "Stock Materiales",
   "tabla Empleados", 
   localStorage.getItem("user"));
}, []);

  return (
    <>
      <Navbar />
      <Container maxWidth="xl" mt={1}>
        {empleados && tabla ? (
          <Box mt={2} mb={4}>
            <ThemeProvider theme={tableTheme}>
              <MaterialReactTable
                autoResetPageIndex={false}
                enableToolbarInternalActions={true} //las acciones al lado del search (agregar y full screen)
                enableGrouping // para permitir agrupar x estado x ej
                layoutMode="grid"
                muiTableHeadCellProps={tableHeadCellProps}
                muiTableBodyCellProps={({ row }) => ({
                  align: "left",
                  sx: {
                    backgroundColor:
                      row.original.estado === 0 ? "#efc3c3" : "#b3e6b3",
                    color: "black",
                    borderColor: "black",
                  },
                })}
                enableColumnFilters={false} //desactiva filtros x  columna
                enableHiding={false} // opcion de ocultar columna pero activando el enablecolumaction
                enableDensityToggle={false} //
                localization={MRT_Localization_ES} //idioma
                enableColumnDragging={false} //para arrastrar columnas
                initialState={initialState}
                muiSearchTextFieldProps={muiSearchTextFieldProps}
                columns={columns}
                data={empleados} //con lo q la completas (esto cambia siempre)
                enableStickyFooter
                enableRowActions
                // enableEditing  //para que se pueda editar desde tabla
                positionActionsColumn="last" // posicion de la columna de acciones al final
                renderDetailPanel={({ row }) => (
                  <DetalleEmpleado row={row.original} />
                )}
                // ACCIONES
                renderToolbarInternalActions={(
                  { table } // boton para nuevo , al lado del buscar
                ) => (
                  <>
                    {!hiddenmuestraactivos ? (
                      <Tooltip title="Ver empleados activos">
                        <IconButton
                          color="success"
                          onClick={() => {
                            obtenerActivos();
                          }}
                        >
                          <DeleteIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    {!hiddenmuestrainactivo ? (
                      <Tooltip title="Ver empleados inactivos">
                        <IconButton
                          color="error"
                          onClick={() => {
                            obtenerinactivos();
                          }}
                        >
                          <DeleteForeverIcon />
                        </IconButton>
                      </Tooltip>
                    ) : null}
                    <MRT_FullScreenToggleButton table={table} />
                  </>
                )}
                renderTopToolbarCustomActions={(row, table) => (
                  <>
                    <Button
                      onClick={() => {
                        handleClickAgregarEmpleado();
                      }}
                      color="primary"
                      //   style={{ backgroundColor: blueGrey[700], color: "white" }}
                      variant="contained"
                      size="small"
                      endIcon={<AddCircleOutlineIcon color="asd" />}
                    >
                      Agregar Empleado
                    </Button>
                    <Typography variant="poster" fontSize={26}>
                      Empleados
                    </Typography>
                    <Button
                      variant="contained"
                      color="primary"
                      endIcon={<FileDownloadIcon />}
                      onClick={handleExportCSV}
                      style={{ backgroundColor: blueGrey[700], color: "white" }}
                      size="small"
                    >
                      Exportar a CSV
                    </Button>
                  </>
                )}
                renderRowActions={({ row, table }) => (
                  <>
                    <div>
                      <Tooltip arrow placement="left" title="Editar">
                        <IconButton
                          onClick={() =>
                            handleClickEditarEmpleado(row.original)
                          }
                          color="primary"
                        >
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                      {row.original.estado === 0 ? (
                        <Tooltip title="Marcar como activo">
                          <IconButton
                            color="success"
                            onClick={() => abrirModalConfirmar(row.original)}
                          >
                            <CheckCircleOutlineIcon />
                          </IconButton>
                        </Tooltip>
                      ) : (
                        <Tooltip title="Marcar como inactivo">
                          <IconButton
                            onClick={() => abrirModalConfirmar(row.original)}
                            color="error"
                          >
                            <BlockIcon />
                          </IconButton>
                        </Tooltip>
                      )}
                    </div>
                  </>
                )}
              />
            </ThemeProvider>
          </Box>
        ) : null}
      </Container>
      {confirmar ? (
        <div>
          <Dialog
            open={confirmar}
            onClose={handleVolver}
            maxWidth="xs"
            fullWidth
          >
            <Box mt={1} backgroundColor={"#1F618D"}>
              <DialogTitle>
                {datosEmpleado.estado === 0 ? (
                  <Typography variant="h6" align="center" color="#ffffff">
                    Marcar como activo a : {datosEmpleado.nombre}{" "}
                    {datosEmpleado.apellido}
                  </Typography>
                ) : (
                  <Typography variant="h6" align="center" color="#ffffff">
                    Marcar como inactivo a : {datosEmpleado.nombre}{" "}
                    {datosEmpleado.apellido}
                  </Typography>
                )}
              </DialogTitle>
            </Box>
            <form onSubmit={marcarInactivo}>
              <Box
                border={0.5}
                borderColor={grey[300]}
                backgroundColor="#F4F6F6"
                p={2}
                py={2}
                mt={1}
              >
                <DialogContent>
                  <DialogContentText textAlign={"center"}>
                    {datosEmpleado.estado === 0 ? (
                      <>
                        {" "}
                        <b>¿Desea marcar como activo al empleado ?</b>{" "}
                      </>
                    ) : (
                      <>
                        {" "}
                        <b>¿Desea marcar como inactivo al empleado ?</b>{" "}
                      </>
                    )}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Grid
                    container
                    direction="row"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Button
                      variant="contained"
                      onClick={handleVolver}
                      style={{ backgroundColor: "#d32f2f", color: "#ffffff" }}
                    >
                      Volver
                    </Button>
                    <Button
                      style={{ backgroundColor: "#2e7d32", color: "#ffffff" }}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      Confirmar
                    </Button>
                  </Grid>
                </DialogActions>
              </Box>
            </form>
          </Dialog>
        </div>
      ) : null}
      {editarEmpleado && (
        <EditarEmpleado
          open={editarEmpleado}
          setOpen={handleCloseEditar}
          row={row}
          empleados={empleados}
        />
      )}
      {agregarEmpleado && (
        <AgregarEmpleado
          open={agregarEmpleado}
          setOpen={handleCloseAgregar}
          empleados={empleados}
        />
      )}
    </>
  );
}

export default Stock_empleados;
